<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="7"
            y="0"
            width="10"
            height="20"
        >
            <rect x="7" width="9.16667" height="20" fill="white"></rect>
        </mask>
        <g mask="url(#mask0)">
            <path
                d="M5.33334 18.3333L13.6667 9.99999L5.33334 1.66666"
                :stroke="color"
                stroke-width="1"
            ></path>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'ChevronSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
